module.exports = __webpack_public_path__ + "img/mc_vrt_pos.87cb71b1.svg";